import { useEffect, useRef } from "react";
import "@foundit/ui-library/dist/index.css";
import "@foundit/drawerApp/dist/DrawerApp.css";
import "@foundit/recruiterHeader/dist/RecruiterHeader.css";
import "@foundit/genericdownload/dist/GenericDownload.css";
import "@foundit/quick-search/dist/QuickSearch.css";
import RecruiterHeader from "@foundit/recruiterHeader";
import { MIDDLEWARE } from "./constants/api";
 
const ClientHeader = () => {
  const headerRef = useRef<any>(null);
 
  useEffect(() => {
    if (typeof window !== "undefined") {
      (window as any).__globalHeaderRef__ = headerRef;
    }
  }, []);
 
  return (
    <>
      <RecruiterHeader
        environment={
          process.env.REACT_APP_CT_PROD_PROJECT_ID ||
          process.env.REACT_APP_CT_TEST_PROJECT_ID ||
          "TEST-944-RZ9-9Z7Z"
        }
        page_name={"JPMS"}
        middleware={""}
        ref={headerRef}
        isClevertapOn={false}
        // isRecallGetUser={true} //true if u want to call get user api every reload other wise will get it from session
        showBetaTag={false}
        isLoggedIn
        subContainerStyles={{ maxWidth: "unset", padding: "0 24px 0 24px" }}
        hideQuickSearch={true}
        page="jpms"
      />
    </>
  );
};
 
export default ClientHeader;
